import icuMessageFormat from "refractor/icu-message-format";
export default icuMessageFormat;